import React, { Component } from "react";

export default class TheInput extends Component {
  render() {
    const presetStyle =
      this.props.type === "date" || this.props.type === "number"
        ? {
            placeholder: "",
            style: { width: "100%", height: 40 },
          }
        : {};
    return (
      <input
        type={this.props.type ?? "text"}
        className="form-control"
        value={this.props.value}
        disabled={this.props.isDisabled}
        placeholder={this.props.placeholder}
        required={this.props.isRequired}
        name={this.props.name}
        onChange={this.props.onChange}
        style={this.props.style}
        {...presetStyle}
      />
    );
  }
}
